import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HttpClient from 'services/HttpClient';
import { getUserToken } from 'services/utils';
import { getBaseNewURL } from 'services/getBaseURL';

const http = new HttpClient();
const baseURL = getBaseNewURL().base;

const initialState = {
	wallets: null,
	message: '',
	loading: {
		backdrop: false,
		form: false,
		skeleton: false,
		input: false,
		button: false,
	},
};

const createAuthenticatedAsyncThunk = (type, url, method = 'post') => {
	return createAsyncThunk(type, async (params, thunkAPI) => {
		const token = getUserToken(thunkAPI);
		const { isToastfy, ...rest } = params || {};

		const config = {
			headers: {
				'Authorization': token,
			},
		};

		const response = await http[method](`${baseURL}${url}`, rest, config, isToastfy);
		return response.data;
	});
};

export const GetWalletHome = createAuthenticatedAsyncThunk('/GetWalletHome', '/Wallets');
export const SetWalletAsDefault = createAuthenticatedAsyncThunk('/SetWalletAsDefault', '/SetWalletOrder');

const HomeWalletSlice = createSlice({
	name: 'walletHome',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(GetWalletHome.pending, (state) => {
				state.loading.skeleton = true;
			})
			.addCase(GetWalletHome.fulfilled, (state, action) => {
				state.loading.skeleton = false;
				const { Success, Message, Content } = action.payload;
				if (Success) {
					state.wallets = Content.Wallets || [];
				} else {
					state.message = Message;
				}
			})
			.addCase(GetWalletHome.rejected, (state) => {
				state.loading.skeleton = false;
				state.message = 'خطا در برقراری ارتباط با سرور';
			})
			.addCase(SetWalletAsDefault.pending, (state) => {
				state.loading.button = true;
			})
			.addCase(SetWalletAsDefault.fulfilled, (state) => {
				state.loading.button = false;
			})
			.addCase(SetWalletAsDefault.rejected, (state) => {
				state.loading.button = false;
			});
	},
});

export default HomeWalletSlice.reducer;
